import { Component, EventEmitter, OnDestroy, OnInit, Output, signal } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FloorClass } from '../../models/floor.class';
import { Settings } from '../actions-toolbar/settings/settings.model';
import { SettingsService } from '../actions-toolbar/settings/settings.service';
import { EDPElevatorBank, ElevatorBankProcessed } from './elevator-banks/elevator-banks.model';
import { FloorContainer } from './floor-container.model';
import { DataObject } from '../../models/data-object.models';
import { FloorContainerRepository } from './floor-container-repository.service';
import { Observable, filter, map, tap } from 'rxjs';
import { ElevatorBanksRepository } from './elevator-banks/elevator-banks-repository.service';
import { StackingPlanService } from '../../stacking-plan.service';
import { StackPlanViewStateService } from '../../state/sp-view-state.service';

@UntilDestroy()
@Component({
  selector: 'sp-floor-container',
  templateUrl: './floor-container.component.html',
  styleUrls: ['./floor-container.component.scss'],
  standalone: false,
})
export class FloorContainerComponent implements OnInit, OnDestroy {
  @Output() floorsData: EventEmitter<{
    floorData: FloorClass[];
    elevatorInfoProcessed: ElevatorBankProcessed[][];
  }> = new EventEmitter();

  totalNumberOfFloors: number;
  elevatorData: EDPElevatorBank[];
  elevatorBankData: ElevatorBankProcessed[][];
  floorData$: Observable<FloorClass[]>;
  settings: Settings;
  containerRecordFloors: DataObject[];

  selectedUsage = signal(null);
  highlightVirtualFloor = signal(false);

  constructor(
    private settingsService: SettingsService,
    private stackingPlanService: StackingPlanService,
    private floorContainerRepository: FloorContainerRepository,
    private elevatorBanksRepository: ElevatorBanksRepository,
    private spViewState: StackPlanViewStateService
  ) {}

  ngOnInit() {
    this.getSettings();

    this.stackingPlanService.containerData$
      .pipe(untilDestroyed(this))
      .subscribe(() => this._setFloorContainerData(this.stackingPlanService.floorContainerData));

    this.floorData$ = this.floorContainerRepository.floorData$.pipe(
      untilDestroyed(this),
      map(floorData => (floorData?.length > 0 ? floorData : null)),
      tap(() => (this.elevatorBankData = this.elevatorBanksRepository.elevatorBanksMatrix))
    );

    this.spViewState.onStateChange$
      .pipe(
        untilDestroyed(this),
        map(state => state.propertyType)
      )
      .subscribe(u => this.selectedUsage.set(u));
  }

  private getSettings() {
    this.settingsService.settings$.pipe(untilDestroyed(this), filter(Boolean)).subscribe(settings => {
      this.settings = settings;
    });
  }

  private _setFloorContainerData(containerData: FloorContainer) {
    const { elevatorBank, floors, totalNumberOfFloors, isSelectedUsagePrimary, hasUsagePrimary } = containerData || {};
    this.totalNumberOfFloors = totalNumberOfFloors;
    this.elevatorData = elevatorBank;
    this.containerRecordFloors = floors;
    this.highlightVirtualFloor.set(!hasUsagePrimary || isSelectedUsagePrimary);
  }

  ngOnDestroy() {
    /* required by untilDestroyed */
  }
}
